import React from "react";
import "./ContactSocialSection.css";
import { FaLinkedin, FaInstagram, FaYoutube, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; 

const ContactSocialSection = () => {
  return (
    <section className="contact-social">
      <div className="social-content">
        <h2>Follow Us & Stay Connected 🌍</h2>
        <p>
          Join the <span>MBR Network’s</span> community on social media to get
          daily career tips, business insights, digital updates, and success
          stories that inspire growth every day.
        </p>

        <div className="social-icons">
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer"
            className="social linkedin"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noreferrer"
            className="social instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com"
            target="_blank"
            rel="noreferrer"
            className="social youtube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noreferrer"
            className="social twitter"
          >
            <FaXTwitter />
          </a>
        </div>

        <p className="tagline">
          Let’s grow, learn, and win together every single day. 💪✨
        </p>
      </div>
    </section>
  );
};

export default ContactSocialSection;
